module.exports = __webpack_public_path__ + "static/media/search_icon.9dc71b35.svg";